exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sales-ranking-print-modal[data-v-24071d47] .ant-modal { top: 20px; height: 95%;\n}\n.sales-ranking-print-modal[data-v-24071d47] .ant-modal-body { height: calc(100% - 55px); overflow: auto;\n}\n.preview-wrapper[data-v-24071d47] { background: #fff; min-height: 400px;\n}\n.print-content[data-v-24071d47] { background: #fff;\n}\n.no-template[data-v-24071d47] { padding: 80px 0; text-align: center;\n}\n", ""]);

// exports
